import React, { Component } from 'react';

import FadeIn from '../_core/components/FadeIn';
import JumpLink from '../_core/components/JumpLink';
import Template from '../_core/components/Template';
import Content from '../_core/components/Content';
import Link from '../_core/components/Link';
import Image from '../_core/components/Image';


// Project
import Project from '../components/';

class Default extends Component {

	constructor(props) {
		super(props);
	}

	componentDidMount() {
	
	}

	componentWillUnmount() {

	}

	/*

		RENDER

	*/

	render() {


		return (
			
			<Template>
				<FadeIn>

					<JumpLink className="Template-jumpLink" to={window.innerHeight}>
						<Project.InteractiveIntro />
					</JumpLink>

					<div className="Template-background">
						<Project.Background />
					</div>

		
					<div className="Template-item Template-item--1">
						<Content html={`<h3>Overview</h3><h1>Make your mark on one of London's most cherished neighbourhoods.</h1>`} />
					</div>

					<div className="Template-item Template-item--2">
						<Content html={`<p>67 Whitfield Street forms part of the 80 Charlotte Street campus offering a 1,760 sq ft Class E restaurant / café opportunity in an exciting catchment area.<br /><br />80 Charlotte Street is an all-electric island site providing over 300,000 sq ft of creative office space. Largely let to Arup, Boston Consulting Group and Lee & Thompson, it's a world-class business destination providing a captive audience of over 3,000 people on your doorstep, in a prime, central location.</p>`} />
					</div>

					<div className="Template-item Template-item--3">
						<Image src={`/ui/img/cgi/4.jpg`} fluid={false} ratio={6/5} />
						<div data-grid-of="2">
				      		<div />
				      		<div><Content><p><Link to={`/#/image/1/`}>View Gallery</Link></p></Content></div>
				      	</div>
					</div>

					<div className="Template-item Template-item--4">
						<Content html={`<h3>More information</h3>`} />
					    <Link className="Link Link--button" to={`#/download/`}>Download Brochure</Link>
					</div>

					<div className="Template-item Template-item--5">
						<Content modifier="agents" html={`
							<h3>Contact details</h3>
							<h1>Get in touch</h1>

							<p><strong>Distrkt</strong><br />
							+44 (0) 203 828 0498<br />
							<br />
							Camila Topham<br />
							<a href="mailto:camilla@distrkt.uk">camilla@distrkt.uk</a><br />
							<br />
							Soraya Tavakoli <br />
							<a href="mailto:soraya@distrkt.uk">soraya@distrkt.uk</a></p>

							<p><strong>Shackleton</strong><br />
							+44 (0) 207 183 8571<br />
							<br />
							Tony Moore<br />
							<a href="mailto:tony.moore@shackletonproperty.com">tony.moore@shackletonproperty.com</a><br />
							<br />
							Jon Puddifant<br />
							<a href="mailto:jp@shackletonproperty.com">jp@shackletonproperty.com</p>

						`} />

					</div>
					
					<Project.InteractiveDownloads
					content={
						<Content modifier="downloads">
	                      <p>To download the 67 Whitfield Street brochure please enter your email address:</p>
	                    </Content>
					}
					terms={

						<Content modifier="caption"><h6>I agree that by submitting this form, I accept the website’s terms of use and <a href="https://www.derwentlondon.com/texts/privacy-policy">privacy policy</a></h6><h6>We will only use your data in connection with sending you this brochure for Charlotte & Whitfield. If you wish to unsubscribe, please email us (name, company, email) at <a href="mailto:mail@derwentlondon.com">mail@derwentlondon.com</a></h6></Content>

					}
					gated={
						<React.Fragment>
							<Content modifier="downloads">
	                      	<p>Thanks. Please download the PDF below.</p>
	                    	</Content>
							<Link className="Link Link--button" to={'/pdf/67_Whitfield_Street_Brochure_151121.pdf'}>Download Brochure</Link>
						</React.Fragment>

					}
					domain={`derwentlondon.us6.list-manage.com`}
					userId={`5e104ea2e28a4b8fc7ec478fd`}
					listId={`e015452a4b`}
					/>
					<Project.InteractiveLightbox total={6} captions={

						[
							
							`67 Whitfield Street cgi`,
							`67 Whitfield Street cgi`,
							`67 Whitfield Street cgi`,
							`67 Whitfield Street`,
							`80 Charlotte Street campus`,
							`The Poets’ Park, Chitty Street`
						]

					}/>

				</FadeIn>
			</Template>
		
		);

	}
}

export default Default;



// WEBPACK FOOTER //
// ./src/js/templates/index.js